import type { Survey, SurveyConfig } from '@dmp/qqms/types';

export const defaultSurveyConfig: SurveyConfig = {
    cards: [],
    traxexLabel: '',
    aboutCopy: '',
};

export const defaultSurvey: Survey = {
    ...defaultSurveyConfig,
    id: '',
    versionId: 'tbd',
    qqid: '',
};
